"use strict";

exports.__esModule = true;
exports.utils = void 0;
var _ = _interopRequireWildcard(require("lodash"));
var _urijs = _interopRequireDefault(require("urijs"));
var _httpClient = require("@wix/http-client");
var _photographyClientLib = require("@wix/photography-client-lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var httpClient = new _httpClient.HttpClient();
var Utils = /*#__PURE__*/function (_RenderUtils) {
  /* @ngInject */
  function Utils() {
    var _this;
    _this = _RenderUtils.call(this) || this;
    _defineProperty(_this, "data", {
      set: function set(key, value) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return _photographyClientLib.Wix.Data.Public.set(dataKey, value, {
            scope: 'APP'
          }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      },
      get: function get(key) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return _photographyClientLib.Wix.Data.Public.get(dataKey, {
            scope: 'APP'
          }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      }
    });
    _defineProperty(_this, "gallerySettings", function () {
      var baseUrl = _photographyClientLib.window.location.protocol + '//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/';
      var getGallerySettingsApi = function getGallerySettingsApi() {
        return "" + baseUrl + _photographyClientLib.window.galleryId + "?instance=" + _photographyClientLib.window.instance + "&isStore=" + _this.isStoreGallery();
      };
      return {
        get: function get(key) {
          return httpClient.get(getGallerySettingsApi(), {
            withCredentials: true,
            xsrfCookieName: null
          }).then(function (_ref) {
            var data = _ref.data;
            return data.settings ? key ? data.settings[key] : data.settings : null;
          });
        },
        set: function set(key, value) {
          var _this$gallerySettings;
          return _this.gallerySettings.setMultiple((_this$gallerySettings = {}, _this$gallerySettings[key] = value, _this$gallerySettings));
        },
        setMultiple: function setMultiple(keysValuesObject) {
          return _this.gallerySettings.get().then(function (data) {
            data = data || {};
            var settings = Object.assign(data, keysValuesObject);
            return httpClient.put(getGallerySettingsApi(), {
              settings: settings
            }, {
              withCredentials: true,
              xsrfCookieName: null
            }).then(function () {
              return _this.setExternalId();
            });
          });
        },
        getAppSettings: function () {
          var _getAppSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(key) {
            var _value, value;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!_photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                    _context.next = 12;
                    break;
                  }
                  _context.prev = 1;
                  _context.next = 4;
                  return _this.appSettings.get(_photographyClientLib.Consts.dataSavedState.SAVED, key);
                case 4:
                  _value = _context.sent;
                  if (!(_value !== undefined)) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return", Promise.resolve(_value));
                case 7:
                  _context.next = 12;
                  break;
                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](1);
                  console.error('Failed to get ' + key + ' from app settings: ' + _context.t0);
                case 12:
                  _context.next = 14;
                  return _this.gallerySettings.get(key);
                case 14:
                  value = _context.sent;
                  try {
                    if (_photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                      _this.appSettings.set(key, value);
                    }
                  } catch (error) {
                    console.error('Failed to set ' + key + ' to app settings: ' + error);
                  }
                  return _context.abrupt("return", Promise.resolve(value));
                case 17:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[1, 9]]);
          }));
          function getAppSettings(_x) {
            return _getAppSettings.apply(this, arguments);
          }
          return getAppSettings;
        }()
      };
    }());
    _this._cache = {};
    _this._hash2int = {};
    _this._refs = {};
    _this._params = {};
    _this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
    _this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';
    _this.openManagePhotos = _this.openManagePhotos.bind(_this);
    try {
      document.domain = 'wixapps.net';
    } catch (e) {
      // console.warn('failed to set domain');
    }
    _this.isAccessibilityEnabled(); // populate the cache with the sdk response
    _this.appSettings = new _photographyClientLib.AppSettings();
    return _this;
  }

  // isStoreGallery() {
  //   return true
  // }
  _inheritsLoose(Utils, _RenderUtils);
  var _proto = Utils.prototype;
  _proto.addItemHashParam = function addItemHashParam(baseUrl, photoId) {
    var curParamsIndex = baseUrl.indexOf('pro-gallery-item=');
    if (curParamsIndex > 0) {
      baseUrl = baseUrl.substr(0, baseUrl.indexOf('pro-gallery-item=') - 1);
    }
    var prefix = '';
    var hashPart = baseUrl.split('#')[1];
    if (hashPart || hashPart === '') {
      var hasQuestionMark = hashPart.split('?')[1];
      if (hasQuestionMark) {
        prefix = '&';
      } else {
        prefix = '?';
      }
    } else {
      prefix = '#?';
    }
    return baseUrl + prefix + 'pro-gallery-item=' + photoId;
  };
  _proto.removeItemHashParam = function removeItemHashParam(baseUrl) {
    var itemPart = baseUrl.indexOf('pro-gallery-item=');
    // remove anything after the hash
    var newUrl = baseUrl.substr(0, itemPart > 0 ? itemPart - 1 : baseUrl.length);
    newUrl += newUrl.indexOf('#') > 0 ? '' : '#';
    return newUrl;
  };
  _proto.hexToRgba = function hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
  };
  _proto.setStateAndLog = function setStateAndLog(that, caller, state, callback) {
    var _this2 = this;
    if (this.isVerbose()) {
      console.log("State Change Called (" + caller + ")", state);
      var oldState = _.clone(that.state);
      that.setState(state, function () {
        var newState = _.clone(that.state);
        var change = _this2.printableObjectsDiff(oldState, newState, 'state');
        if (_.keys(change).length > 0) {
          console.log("State Change Completed (" + caller + ")", change);
        }
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    } else {
      that.setState(state, function () {
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    }
  };
  _proto.printableObjectsDiff = function printableObjectsDiff(obj1, obj2, prefix) {
    if (prefix === void 0) {
      prefix = '';
    }
    var toString = function toString(v) {
      if (v === '') {
        v = "''";
      } else if (_.isUndefined(v)) {
        v = 'undefined';
      }
      return _.toString(v);
    };
    var _getInnerDiff = function getInnerDiff(obj1, obj2, prefix) {
      var innerDiff = _.reduce(obj1, function (res, v, k) {
        if (!_.isEqual(v, obj2[k])) {
          if (_.isArray(obj2[k])) {
            if (v.length !== obj2[k].length) {
              res[k + '.length'] = '[' + v.length + '] => [' + obj2[k].length + ']';
            }
            res = _.merge(res, _getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else if (_.isObject(obj2[k])) {
            res = _.merge(res, _getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else {
            res[(prefix ? prefix + '.' : '') + k] = toString(v) + ' => ' + toString(obj2[k]);
          }
        }
        return res;
      }, {});
      return innerDiff;
    };
    return _getInnerDiff(obj1, obj2, prefix);
  };
  _proto.getViewportScaleRatio = function getViewportScaleRatio() {
    // 320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
      return 320 / this.getScreenWidth();
    } else {
      return 1;
    }
  };
  _proto.debounceWithContext = function debounceWithContext(context, debouncedFunction, delay) {
    if (delay === void 0) {
      delay = 300;
    }
    return _.bind(_.debounce(debouncedFunction, delay), context);
  };
  _proto.openModalImp = function openModalImp(url, width, height, onClose) {
    if (width === void 0) {
      width = '100%';
    }
    if (height === void 0) {
      height = '100%';
    }
    if (onClose === void 0) {
      onClose = _.noop;
    }
    return new Promise(function (resolve, reject) {
      _photographyClientLib.Wix.Settings.openModal(url, width, height, undefined, function () {
        onClose();
        resolve();
      }, true, {
        overlay: 'rgba(0,0,0,0)',
        background: 'rgba(0,0,0,0)',
        margin: false
      });
    });
  };
  _proto.openManagePhotos = function openManagePhotos() {
    return this.openModalImp(this.getManageMediaUrl());
  };
  _proto.openExpandSettings = function openExpandSettings(params) {
    this.openModalImp(this.getExpandSettingsUrl(params));
  };
  _proto.openSettingsWatermarkDisableDialog = function openSettingsWatermarkDisableDialog(callback) {
    _photographyClientLib.Wix.Settings.openModal(this.getSettingsWatermarkDisableUrl(), 612, 281, undefined, callback, true);
  };
  _proto.openSettingsAddonsUrl = function openSettingsAddonsUrl(params, callback) {
    _photographyClientLib.Wix.Settings.openModal(this.getSettingsAddonsUrl(params), 736, 281, undefined, callback, true);
  };
  _proto.findFontsHrefs = function findFontsHrefs() {
    try {
      var isFontHref = function isFontHref(x) {
        return x.toLowerCase().includes('font');
      };
      var styleSheets = top.document.styleSheets;
      return Object.keys(styleSheets).map(function (s) {
        return styleSheets[s].href;
      }).filter(function (href) {
        return href !== null;
      }).filter(isFontHref);
    } catch (e) {
      // console.warn('could not find fonts hrefs', e);
      return [];
    }
  };
  _proto.getSupportLink = function getSupportLink(progalleryLinks, storeLinks) {
    var editorArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[0] : progalleryLinks[0] : progalleryLinks[0];
    var onBoardingArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[1] : progalleryLinks[1] : progalleryLinks[1];
    var articleUrl = '';
    var isOnboarding = this.isOnBoarding() || !editorArticleId;
    if (editorArticleId || onBoardingArticleId) {
      var widgetCode = '';
      var articleId = '';
      var subDomain = 'support';
      var isOnBoardingReallyExists = isOnboarding && onBoardingArticleId;
      var hasOnBoardingOnly = !editorArticleId && onBoardingArticleId;
      if (isOnBoardingReallyExists || hasOnBoardingOnly) {
        widgetCode = this.CONST_ADI_SUPPORT_WIDGET_CODE;
        articleId = onBoardingArticleId;
      } else if (editorArticleId) {
        widgetCode = this.CONST_EDITOR_WIDGET_CODE;
        articleId = editorArticleId;
      }
      if (_.isUndefined(_photographyClientLib.window.locale)) {
        _photographyClientLib.window.locale = 'en';
      }
      var locale = _photographyClientLib.window.locale;
      var path = "/" + locale + "/widget/" + widgetCode + "/article/" + articleId;
      var url = new _urijs["default"]('https://wix.com/').path(path).subdomain(subDomain);
      articleUrl = url.toString();
    }
    return articleUrl;
  };
  _proto.mergeDeep = function mergeDeep() {
    var _mergeDeep2 = function _mergeDeep(dstObj, srcObj) {
      var mergeId;

      // const clonedDstVal = _.cloneDeep(dstObj);
      var res = _.mergeWith(dstObj, srcObj, function (dstVal, srcVal) {
        if (_.isObject(dstVal) && !_.isFunction(dstVal)) {
          // isObject return true for functions too
          return _mergeDeep2(dstVal, srcVal);
        } else {
          return srcVal;
        }
      });
      return res;
    };
    var merged = {};
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        merged = _mergeDeep2(merged, arguments[i]);
      }
    }
    return merged;
  };
  _proto.getImageUrl = function getImageUrl(fileName) {
    return (_photographyClientLib.window.staticsUrl || '') + fileName;
  };
  _proto.markWidgetInSite = function markWidgetInSite(widgetId) {
    var instanceId = _photographyClientLib.window.instanceId;
    this.getLocalStorage()[instanceId + '|has-widget|' + widgetId] = true;
  };
  _proto.isWidgetInSite = function isWidgetInSite(widgetId) {
    var instanceId = _photographyClientLib.window.instanceId;
    return !_.isUndefined(this.getLocalStorage()[instanceId + '|has-widget|' + widgetId]);
  };
  _proto.getMobileEnabledClick = function getMobileEnabledClick(action) {
    // todo: bring back this line before pushing to master
    return this.isMobile() ? {
      onTouchEnd: action
    } : {
      onClick: action
    };
    // return {onClick: action};
  };
  _proto.uploadImageFromUrl = function uploadImageFromUrl(imageUrl) {
    var imageUrlTemplateBase64 = _photographyClientLib.window.btoa(imageUrl);
    var updloadMediaUrlTemplate = location.protocol + "//files.wix.com/files/upload/external?media_type=picture&ns=campaign&name=_.jpg&url=" + encodeURIComponent(imageUrl);
    return this.getUploadMediaRequest(updloadMediaUrlTemplate, 10000);
  };
  _proto.getUploadMediaRequest = function getUploadMediaRequest(uploadMediaUrl, timeout) {
    return httpClient.request({
      url: uploadMediaUrl,
      method: 'GET',
      timeout: timeout,
      withCredentials: true,
      xsrfCookieName: null
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  };
  _proto.isInExpandSettings = function isInExpandSettings() {
    return this.parseGetParam('expandsettingsmode') === '1';
  };
  _proto.isStoreDemoImages = function isStoreDemoImages() {
    var _this3 = this;
    // NOTE: the next few lines are commented because otherwise cannot check debugApp=ph_local/ph_debug
    // if (this.isDev()) { //development mode cannot upload images so is is default false
    //   return Promise.resolve(false);
    // }
    if (this.isInExpandSettings()) {
      // expand settings uses default images
      return Promise.resolve(true);
    }
    return this.gallerySettings.getAppSettings('isStoreDemoImages').then(function (isDemo) {
      if (isDemo === undefined) {
        throw 'not in gallerySettings, fallback to dataPublic';
      }
      return isDemo;
    })["catch"](function (e) {
      return _this3.data.get('isStoreDemoImages').then(function () {
        return false;
      })["catch"](function (e) {
        if (_this3.isDev()) {
          console.log('error fetching store default images', e);
        }
        return !!(e && e.error && e.error.message && e.error.message.indexOf('not found in APP scope') > 0);
      });
    });
  };
  _proto.getProviderFromGalleryInfo = function getProviderFromGalleryInfo(galleryInfo) {
    if (galleryInfo && galleryInfo.connectedProviders) {
      return Object.keys(galleryInfo.connectedProviders)[0];
    }
    return null;
  };
  _proto.dataPublicKey = function dataPublicKey(key) {
    try {
      var compId = _photographyClientLib.Wix.Utils.getOrigCompId() || _photographyClientLib.Wix.Utils.getCompId();
      return key + '-' + compId;
    } catch (e) {
      // console.error('Cannot get compId', e);
      return key + '-no-comp-id';
    }
  };
  _proto.openMediaDialogAndApplyWatermark = function openMediaDialogAndApplyWatermark(callback) {
    _photographyClientLib.Wix.Dashboard.openMediaDialog(_photographyClientLib.Wix.Settings.MediaType.IMAGE_PRO, true, function (result) {
      var galleryId = _photographyClientLib.window.galleryId;
      var instance = _photographyClientLib.window.instance;
      _photographyClientLib.watermarkApi.applyWatermarkOnMediaDialogResult(result, galleryId, instance).then(function (watermarkData) {
        callback(result);
      });
    });
  };
  _proto.colorStringToObject = function colorStringToObject(colorString) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    try {
      var returnValue = null;
      if (typeof colorString === 'string') {
        if (colorString.trim().indexOf('rgb') === 0) {
          // rgb(1,2,3) | rgba(4,5,6,0.7)
          var values = colorString.match(/\d+/g);
          if (values && Array.isArray(values) && values.length >= 3) {
            returnValue = {
              r: values[0],
              g: values[1],
              b: values[2]
            };
          }
        } else {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
          });
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
          returnValue = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }
      }
      return returnValue;
    } catch (error) {
      console.error('Error converting color string to object', error);
    }
  };
  _proto.getExperimentValue = function getExperimentValue(experimentName) {
    return _.get(_photographyClientLib.window, ['petri', "specs.pro-gallery." + experimentName]);
  };
  _proto.getDateCreatedTicksFromStr = function getDateCreatedTicksFromStr(dateCreatedStr) {
    var dateCreatedTicks = null;
    var isDateCreatedValid = isNaN(Date.parse(dateCreatedStr)) === false;
    if (isDateCreatedValid) {
      return Date.parse(dateCreatedStr);
    }
    return -8640000000000000;
  };
  _proto.getQueryParamByName = function getQueryParamByName(name, url) {
    if (url === void 0) {
      url = _photographyClientLib.window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };
  _proto.getBaseUrl = function getBaseUrl() {
    if (_photographyClientLib.window.location.origin.includes('manage.editorx')) {
      return '//manage.editorx.com';
    }
    return '//manage.wix.com';
  };
  return Utils;
}(_photographyClientLib.RenderUtils);
var utils = exports.utils = new Utils();